import React from 'react';

import { colapsarEspacios } from 'src/utilidades';

interface NombrePersonalDTO {
    readonly primerNombre: string;
    readonly nombresSecundarios: string;
    readonly apellidoPaterno: string;
    readonly apellidoMaterno: string;
}

export type NombrePersonalProps = {
    readonly nombre: NombrePersonalDTO;
    /**
     * Patrón que definirá las partes que serán renderizadas. Se admiten modificadores,
     * donde cada uno comienza por `%` seguido de una letra. Los siguientes modificadores
     * son válidos:
     *
     * - `%N`: primer Nombre
     * - `%S`: nombres Secundarios
     * - `%P`: apellido Paterno
     * - `%M`: apellido Materno
     * - `%n`: inicial del primer Nombre
     * - `%s`: inicial del nombres Secundarios
     * - `%p`: inicial del apellido Paterno
     * - `%m`: inicial del apellido Materno
     *
     * Si se pasa un modificador inválido o cualquier otro caracter, será copiado tal cual
     * al texto renderizado.
     *
     * Si se omite, usará por defecto el patrón `'%N %S %P %N'` que renderizará el nombre
     * completo, en orden, con los nombres primero, cada parte separada por un espacio.
     */
    readonly patron?: string;
};

export class NombrePersonal extends React.PureComponent<NombrePersonalProps> {
    public render() {
        const { nombre, patron = '%N %S %P %M' } = this.props;
        return <>{nombreTraducidoDesdePatron(patron, nombre)}</>;
    }
}

export default NombrePersonal;

function soloIniciales(frase: string): string {
    return frase
        .split(' ')
        .map(p => p.charAt(0))
        .join(' ');
}

function nombreTraducidoDesdePatron(patron: string, nombrePersonal: NombrePersonalDTO): string {
    const enum Estado {
        Caracter,
        Modificador,
    }

    let estado: Estado = Estado.Caracter;
    let resultado = '';
    for (const c of patron) {
        if (estado === Estado.Caracter) {
            if (c === '%') {
                estado = Estado.Modificador;
                continue;
            }
            resultado += c;
        } else {
            switch (c) {
                case 'N':
                    resultado += nombrePersonal.primerNombre;
                    break;
                case 'S':
                    resultado += nombrePersonal.nombresSecundarios;
                    break;
                case 'P':
                    resultado += nombrePersonal.apellidoPaterno;
                    break;
                case 'M':
                    resultado += nombrePersonal.apellidoMaterno;
                    break;
                case 'n':
                    resultado += soloIniciales(nombrePersonal.primerNombre);
                    break;
                case 's':
                    resultado += soloIniciales(nombrePersonal.nombresSecundarios);
                    break;
                case 'p':
                    resultado += soloIniciales(nombrePersonal.apellidoPaterno);
                    break;
                case 'm':
                    resultado += soloIniciales(nombrePersonal.apellidoMaterno);
                    break;
                default:
                    resultado += '%' + c;
                    break;
            }
            estado = Estado.Caracter;
        }
    }
    return colapsarEspacios(resultado);
}



// WEBPACK FOOTER //
// ./src/componentes/NombrePersonal/index.tsx